import * as S from "./VwoDebug.styles";
import { useVwo } from "context/VwoContext";

export const VwoDebug = () => {
  // #############################################################################
  // AB test
  // #############################################################################
  const { campaigns } = useVwo();

  // #############################################################################
  // Render
  // #############################################################################
  if (__CONFIG__.isProd || !campaigns.length) {
    return null;
  }

  return (
    <S.Wrap>
      {campaigns.map((campaign) => (
        <S.Campaign key={campaign.name}>
          <S.Name>{campaign.name}</S.Name>
          <S.Variation>{campaign.variation}</S.Variation>
        </S.Campaign>
      ))}
    </S.Wrap>
  );
};
